import styled from "styled-components/native";

import { Text2, Text3 } from "~/components/text";
import { spacers } from "~/styles/theme";

export const Container = styled.View`
  margin-vertical: ${spacers.ss8};
  max-width: 500px;
`;

export const StepContainer = styled.View`
  margin-bottom: ${spacers.ss4};
  align-items: center;
`;

export const StepTitle = styled(Text3)`
  font-family: SFProDisplay-Bold;
  margin-bottom: ${spacers.ss5};
`;

export const StepDescription = styled(Text3)`
  color: ${({ theme }) => theme.colors.gray600};
  font-size: 15px;
  margin-bottom: ${spacers.ss4};
  text-align: center;
`;

export const StepDisclaimer = styled(Text2)`
  font-family: SFProDisplay-Regular;
  font-style: italic;
  color: ${({ theme }) => theme.colors.gray600};
  margin-bottom: ${spacers.ss4};
  text-align: center;
`;
